export function resolveAddChannelInvoicePeriod(
    addChannelOption: 'bundle' | 'monthly',
    periodInMonths?: number | null
): string {
    if (addChannelOption === 'monthly') {
        return '1'
    }
    const months = Number(periodInMonths)
    if (Number.isFinite(months) && months > 0) {
        return String(months)
    }
    return '1'
}

export function resolveBillingInvoicePeriod(params: {
    subscriptionPeriod?: string | null
    isFirstPurchase?: boolean
    selectedSubscriptionPeriod?: string | null
}): string {
    const sub = params.subscriptionPeriod
    if (!sub) {
        return params.selectedSubscriptionPeriod ?? '1'
    }
    if (params.isFirstPurchase && sub === '1') {
        return '2'
    }
    return sub
}
